// eslint-disable-next-line no-unused-vars
var __webpack_public_path__;
__webpack_public_path__ = window.SERVER_ENV.ASSET_PATH;
